import { memo, useEffect } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { SANKEY } from '../../constants/visualizationTypes';
//@ts-expect-error Untyped dependency
import Highchart from '../../highcharts/Highchart';
//@ts-expect-error Untyped dependency
import { getDefaultOptions } from '../../highcharts/options/defaultOptions';
import { defaultSankeySeriesOptions } from '../../highcharts/options/series/sankeySeriesOptions';
import { getTooltipFormatter } from './options/tooltips';
import { getColumnHeaders, getHighchartNodes, getNodeLabels } from './options/nodesAndColumns';
import { getChartOptions } from './options/chartOptions';
import { getDropoffByNode, getSeriesOptions } from './options/seriesOptions';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { jsx as _jsx } from "react/jsx-runtime";
export const type = SANKEY;
export const record = visualization => visualization;
const mapDataToLinks = (dataset, {
  originField,
  destinationField
}) => dataset.data.reduce((map, dataRecord) => {
  const fromKey = dataRecord[originField];
  const linksToMap = Object.assign({}, map[fromKey], {
    [dataRecord[destinationField]]: dataRecord
  });
  return Object.assign({}, map, {
    [fromKey]: linksToMap
  });
}, {});
export const getHighchartsOptions = (visualization, reportingThemes) => {
  const dataset = visualization.data[visualization.dataset];
  const onPointClick = visualization.events.onPointClick || emptyFunction;
  const layout = visualization.layout;
  const highchartNodes = getHighchartNodes(dataset, layout);
  const nodeLabels = getNodeLabels(dataset, layout);
  const columnHeaders = getColumnHeaders(dataset, layout, nodeLabels, highchartNodes[0].id);
  const chartOptions = getChartOptions(columnHeaders);
  const scaleEnabled = visualization.options && visualization.options.scale || false;
  const removeZeroDropoffNodes = visualization.options && visualization.options.removeZeroDropoffNodes || false;
  const series = getSeriesOptions(dataset, highchartNodes, layout, onPointClick, scaleEnabled, removeZeroDropoffNodes);
  const linksDataMap = mapDataToLinks(dataset, layout);
  return getDefaultOptions({
    reportingThemes
  }).set('series', series).setIn(['plotOptions', 'sankey'], defaultSankeySeriesOptions) //TODO: move plotOptions to defaultOptions
  .mergeDeep(chartOptions).setIn(['tooltip', 'formatter'], getTooltipFormatter(dataset, layout, linksDataMap, nodeLabels, getDropoffByNode(layout)));
};
const SankeyViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize,
  reportingThemes
}) => {
  const viz = visualization.toJS();
  const chartOptions = getHighchartsOptions(viz, reportingThemes);
  useEffect(() => {
    debug.set('Highcharts', chartOptions);
  }, [debug, chartOptions]);
  return /*#__PURE__*/_jsx(Highchart, {
    chartOptions: chartOptions,
    onReportVisualize: onReportVisualize
  });
};
export const Render = /*#__PURE__*/memo(SankeyViz);